import type {AxiosResponse} from "axios";

import {axios} from "@/src/modules/core/lib";

import type {
  HelpApiEnvelope,
  HelpBundle,
  HelpFieldsResponse,
  HelpIndex,
} from "../types";

const PATH = "help";

class HelpApi {
  getIndex(): Promise<AxiosResponse<HelpApiEnvelope<HelpIndex>>> {
    return axios({url: PATH, method: "get"});
  }

  getDomain(domain: string): Promise<AxiosResponse<HelpApiEnvelope<HelpBundle>>> {
    return axios({url: `${PATH}/${domain}`, method: "get"});
  }

  getFieldsByScreen(
    domain: string,
    screen: string,
  ): Promise<AxiosResponse<HelpApiEnvelope<HelpFieldsResponse>>> {
    return axios({
      url: `${PATH}/fields`,
      method: "get",
      params: {domain, screen},
    });
  }

  getFieldsByKeys(keys: string): Promise<AxiosResponse<HelpApiEnvelope<HelpFieldsResponse>>> {
    return axios({
      url: `${PATH}/fields`,
      method: "get",
      params: {keys},
    });
  }
}

export const helpApi = new HelpApi();
